import { axiosV3 } from "../../Utils/Axios/axiosV3";

export const sendFirebaseToken_Service = async (
  firebaseToken: string,
  userToken: string
) => {
  return axiosV3.post(
    "/user/update-web-firebase-token",
    {
      token: firebaseToken,
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
